/** Per-field help copy for the loan application form (shown via "?" icons). */
export const FIELD_HELP: Record<
  string,
  { description: string; example?: string; tip?: string }
> = {
  nameOfApplicant: {
    description: 'Your full legal name as it appears on official documents.',
    example: 'John Muzenda',
  },
  nameOfBusiness: {
    description: 'The registered name of your business (must match registration documents).',
    example: 'ABC Trading Pvt Ltd',
    tip: 'Use the exact name as registered with the Registrar of Companies.',
  },
  statusOfBusiness: {
    description: 'Select whether your business is new or already operating.',
    example: 'New (just starting), Operating (already running)',
  },
  formOfBusinessOwnership: {
    description: 'Legal structure of your business.',
    example: 'Sole Proprietorship, Company, Partnership, etc.',
    tip: 'This determines how many directors/partners you need to add.',
  },
  tradeReferenceDto: {
    description: 'Businesses or suppliers you work with who can vouch for you.',
    tip: 'Add at least 2–3 references to strengthen your application.',
  },
  bankingInfoDto: {
    description: 'Your business bank account details.',
    tip: 'This is where loan funds will be deposited if approved.',
  },
  loanOrDebtDto: {
    description: 'Any other loans or debts your business currently has.',
    tip: 'Be honest — this helps us assess your repayment capacity.',
  },
  firstName: {
    description: 'Your legal first name.',
    example: 'John',
  },
  lastName: {
    description: 'Your legal surname.',
    example: 'Muzenda',
  },
  otherNames: {
    description: 'Any previous names or middle names.',
  },
  idNumber: {
    description: 'Your Zimbabwe National ID number.',
    example: '12-345678Z12',
    tip: 'Format: XX-XXXXXXZXX (with hyphens).',
  },
  dateOfBirth: {
    description: 'You must be at least 18 years old to apply.',
    tip: 'This should match your National ID.',
  },
  loanProduct: {
    description: 'Select the Skyfin loan product that best fits your needs.',
    tip: 'Choose based on what you need the loan for.',
  },
  currency: {
    description: 'Currency for your loan. USD is fixed; ZIG may vary with exchange rates.',
    tip: 'When set by the product, currency cannot be changed.',
  },
  loanAmount: {
    description: 'Enter the amount you wish to borrow (numbers only, no currency symbols).',
    example: '5000, 10000, 25000',
    tip: 'Stay within the product minimum and maximum principal.',
  },
  tenure: {
    description: 'How long you want to repay the loan.',
    tip: 'Longer tenures mean lower monthly payments but more interest.',
  },
  branchName: {
    description: 'Select the SMEDCO branch nearest to you.',
    tip: 'This is where you will collect your loan if approved.',
  },
  loanPurpose: {
    description: 'Explain what you will use the loan for. Be specific and clear.',
    example: 'Working capital, Equipment purchase, Business expansion',
  },
};
